<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de estatus del procesado</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los tipos de estatus del procesado</option>        
        <option v-for="(tipoEstatusProcesado,index) in tiposEstatusProcesado" :value="tipoEstatusProcesado.TipoEstatusProcesadoId" :key="index">{{tipoEstatusProcesado.Nombre}}</option>
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        tiposEstatusProcesado: [],
        idDelModelo:null
      }
    },
    props: {            
      parametros:Object,
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    },
    computed:{
      
    },
    methods: {
      /**
       * Metodo para asignar la llave del elemento seleccionado del catalogo C013TiposEstatusProcesado
       * @param {object} evento [evento emitido por el select]
       */
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        const valoresDelCatalogo =
        {
          llave: this.idDelInput,
          valor: evento.target.value 
        }

        this.$store.dispatch("A_SIVAC_Catalogos_013TiposEstatusProcesado",valoresDelCatalogo);
        this.$emit("valorParaElPadre",evento);
        // para obtener label del select => let labelTipoPagina = evento.target.options[evento.target.selectedIndex].text;
      },
      /**
       * Metodo para llenar catalogo C013TiposEstatusProcesado mediante el llamado de la API
       */
      cargarTiposEstatusProcesado: function() {
        // definimos metodo de API
        const SERVIDOR = api.conexion;
        const METODO_API_AGREGAR = api.SIVAC.catalogos.C013TiposEstatusProcesado;
        let urlApi = SERVIDOR + METODO_API_AGREGAR;
        // creamos la peticion con el formulario
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {};
        
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        let peticionMetodoGetTiposEstatusProcesadoAPI = this.parametros;
        // contruir header de la peticion
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticionMetodoGetTiposEstatusProcesadoAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else {
                        /* utilizar solo en etapa de desarrollo 
                        console.log("ejecuto bien paginas controller:: ",respuesta.data); */
                        this.tiposEstatusProcesado = respuesta.data.TiposEstatusProcesado;


                        if(this.parametros.elementosAOmitir != undefined){
                        this.tiposEstatusProcesado = this.tiposEstatusProcesado.filter(element => {                   
                        if(!this.parametros.elementosAOmitir.includes(element.TipoEstatusProcesadoId))
                        return element;
                        });
                         }

                        if(this.parametros.elementosAConservar != undefined && this.parametros.elementosAConservar != null  && this.parametros.elementosAConservar.length > 0){
                          this.tiposEstatusProcesado = this.tiposEstatusProcesado.filter(element => {                  
                        if(this.parametros.elementosAConservar.includes(element.TipoEstatusProcesadoId))
                        return element;
                        });
                        }


                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
        ) // axios.post
      }
    }, 
    mounted(){
      // establecer valor default
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const valoresDelCatalogo = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
      this.$store.dispatch("A_SIVAC_Catalogos_013TiposEstatusProcesado", valoresDelCatalogo);
    },
    created() {
      this.cargarTiposEstatusProcesado();
    }
  }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/SIVAC/Catalogos/C013TiposEstatusProcesado.vue